<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>
<template>
  <div class="section-container">
    <!-- Title -->
    <h2 class="text-4xl md:text-5xl">{{ $t('Onze Visie: Kwaliteit van Leven Verbeteren') }}</h2>

    <!-- Two-Column Layout -->
    <div class="grid md:grid-cols-2 gap-6">
      <div>
        <!-- <h3 class="text-xl font-semibold text-[#437066]">{{ $t('Zorgblik') }}</h3> -->
        <p
          class="mt-2 text-lg"
        >{{ $t('Zorgblik streeft ernaar de kwaliteit van leven te verbeteren voor mensen die vanwege een verstandelijke beperking en/of psychiatrische problematiek afhankelijk zijn van intensieve 24-uurs zorg. In een uitdagend (politiek) klimaat, waarin de kwaliteit van zorg niet altijd gegarandeerd kan worden ondanks de inzet van instellingen en hun medewerkers, biedt Zorgblik ondersteuning. Wij geloven dat iedereen recht heeft op hoogwaardige zorg en streven naar oplossingen die écht het verschil maken.') }}</p>
      </div>

      <div>
        <!-- <h3 class="text-xl font-semibold text-[#437066]">{{ $t('Kwaliteit') }}</h3> -->
        <p
          class="mt-2 text-lg"
        >{{ $t('Zorgblik biedt innovatieve korte- en langetermijnoplossingen, waarbij ervaren zorgprofessionals flexibel worden ingezet op verschillende niveaus binnen zorgorganisaties. Daarnaast investeren wij in de toekomst via de Zorgblik Academy. Hier leiden we zorgprofessionals van morgen op en bieden we coaching om hen klaar te stomen voor een betekenisvolle carrière in de zorg. Samen bouwen we aan een sterkere, meer duurzame zorgsector.') }}</p>
      </div>
    </div>
  </div>
</template>